import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-flamingo-confirm-dialog',
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p [innerHtml]="data.description"></p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      @if (data.cancel) {
        <button mat-button type="button" color="accent" tabIndex="-1" [mat-dialog-close]="undefined">
          <span>{{ data.cancel }}</span>
        </button>
      }
      <button mat-raised-button color="accent" [mat-dialog-close]="true">
        <span>{{ data.confirm }}</span>
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlamingoConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: FlamingoConfirmDialogOptions) {}
}

export interface FlamingoConfirmDialogOptions {
  title?: string;
  description?: string;
  confirm?: string;
  cancel?: string;
}
